export const isNullOrEmpty = (value: string) => {
  return value === null || value === undefined || value === '' ? true : false
}

export const isValidEmail = (val: string) => {
	const reg = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/
	return (val && reg.test(val))
}